import videojs from 'video.js';
import 'video.js/dist/video-js.css';

import registerQualitySelector from '@silvermine/videojs-quality-selector';
import '@silvermine/videojs-quality-selector/dist/css/quality-selector.css';

registerQualitySelector(videojs);

export default videojs;